var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeacherShow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "dual-color-svg ",
    width: 22,
    height: 22,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Teacher-show"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1082",
    cx: 8,
    cy: 4,
    r: 2.5,
    stroke: "#026094"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 416",
    d: "M4.41682 13.4437C3.81651 13.0754 3.5 12.3614 3.5 11.5503L3.5 9.5C3.5 8.26367 4.80108 7.45956 5.90689 8.01246L6.59605 8.35704C7.47986 8.79895 8.52014 8.79895 9.40395 8.35704L10.0931 8.01246C11.1989 7.45956 12.5 8.26367 12.5 9.5L12.5 11.5503C12.5 12.3614 12.1835 13.0754 11.5832 13.4437C10.7536 13.9527 9.50909 14.5 8 14.5C6.49091 14.5 5.24641 13.9527 4.41682 13.4437Z",
    stroke: "#026094"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 457",
    d: "M7 10L9 12L14 7",
    stroke: "#3AC47D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacherShow);
export default __webpack_public_path__ + "static/media/Teacher-show.17440feedd2e24e141b961da32369a6b.svg";
export { ForwardRef as ReactComponent };